import { useState } from 'react';
import useStateWithLocalStorage from '../helpers/useStateWithLocalStorage';

export default function useInput() {
  const [mail, setMail] = useStateWithLocalStorage('mail');
  const [isTouched, setIsTouched] = useState(false);
  let isValid = mail && mail.match(/^\S+@\S+\.\S+$/) !== null
  let hasError = !isValid && isTouched;

  const inputBlurHandler = () => {
    setIsTouched(true);
  };

  const inputTouchedOnConfirm = () => {
    setIsTouched(true);
  };

  return {
    mail,
    setMail,
    hasError,
    isValid,
    inputBlurHandler,
    inputTouchedOnConfirm,
  };
}
